<template>
    <c-search-mobile-header-top class="search-mobile-header-top">
        <i :class="search_icon_class" @click="toggleDropdownSearch"></i>
        <div class="dropdown-search" :class="{ active: isActive }" @click="isActive = false">
            <div class="content-dropdown-search">
                <form method="get" :action="route_search" id="form_search_term_mb">
                    <input
                        type="search"
                        v-model="searchTerm"
                        name="search_term"
                        id="search_term_mb"
                        placeholder="O que você procura?"
                        value=""
                        @input="filterResults"
                        @click.prevent.stop
                    />
                    <button
                        id="btn_search_term_mb"
                        aria-label="Pesquisar"
                        type="submit"
                    >
                        <i class="fas fa-search"></i>
                    </button>
                </form>
                <div v-if="showResults" id="results-container" class="autocomplete-results">
                    <div
                        v-for="(item, idx) in filtered"
                        :key="item.id || idx"
                        :class="['autocomplete-item']"
                        @mousedown.prevent="selectItem(item)"
                    >
                        {{ item.pro_name_site }}
                    </div>
                    <div v-if="filtered.length === 0" class="emptymessage">Nenhum resultado encontrado!</div>
                </div>
            </div>
        </div>
    </c-search-mobile-header-top>
</template>

<script>
import { CSearchMobileHeaderTop } from "../Styles/Header/styled";

function normalize(str) {
    return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim() : '';
}

export default {
    name: "SearchMobileHeaderTop",
    props: {
        route_search: {
            required: true,
        },
        api_search_url: { required: true }
    },
    components: {
        "c-search-mobile-header-top": CSearchMobileHeaderTop
    },
    data() {
        return {
            isActive: false,
            searchTerm: "",
            apiSearchResult: [],
            filtered: [],
            showResults: false,
        };
    },
    mounted(){
        this.getAllProducts()

    },

    methods: {
        toggleDropdownSearch() {
            this.isActive = !this.isActive;
        },
        async getAllProducts(){
            const url = this.api_search_url;
            try {
                const response = await fetch(url);
                this.apiSearchResult = await response.json();
            } catch (error) {
                console.error('Erro ao buscar dados da API:', error);
            }
            
        },
        filterResults() {
             const words = normalize(this.searchTerm).split(/\s+/).filter(Boolean);
            if (this.searchTerm.length > 2) {
                this.filtered = this.apiSearchResult.filter(item => {
                    const fields = [
                        item.pro_name_site ? normalize(item.pro_name_site) : '',
                        item.api_cod_barra ? String(item.api_cod_barra).toLowerCase() : '',
                        item.api_cod_original ? String(item.api_cod_original).toLowerCase() : ''
                    ];
                    if (fields.every(field => field === '')) return false;
                    return words.every(word =>
                        fields.some(field => field.includes(word))
                    );
            });
        this.showResults = true;
            } else {
                this.filtered = [];
                this.showResults = false;
            }
        },
        selectItem(item) {
            this.searchTerm = item.pro_name_site;
            this.showResults = false;
            this.filtered = [];
             setTimeout(() => {
                 this.$nextTick(() => {
                     document.getElementById('btn_search_term_mb').click();
                 });
             }, 1000);
        },
    },
    computed: {
        search_icon_class() {
            return this.$root.$children[0].theme?.header?.search?.search_icon_class ?? 'fas fa-search'
        }
    }
};
</script>

<style scoped>
    .autocomplete-results {
        position: absolute;
        background: #fff;
        border: 1px solid #ccc;
        width: 100%;
        z-index: 10;
        border-top: none;
        max-height: 200px;
        overflow-y: auto;
        padding: .8rem 1rem;
    }
    .autocomplete-item {
        padding: 8px;
        cursor: pointer;
    }
    .autocomplete-item:hover {
        background: #eee;
    }
    .autocomplete-active {
        background: #eee;
    }
    .emptymessage {
        padding: 8px;
        color: #999;
    }
</style>